import { render } from "./MappingProduct.vue?vue&type=template&id=6c89df40&scoped=true"
import script from "./MappingProduct.vue?vue&type=script&lang=js"
export * from "./MappingProduct.vue?vue&type=script&lang=js"

import "./MappingProduct.vue?vue&type=style&index=0&id=6c89df40&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c89df40"]])

export default __exports__